// NOTE: Values manually added
export const fontSizes = {
	1: '0.75rem',
	50: '0.875rem',
	100: '1rem',
	150: '1.125rem',
	200: '1.25rem',
	300: '1.5rem',
	400: '1.75rem',
	500: '2rem',
	600: '2.25rem',
	700: '2.5rem',
	800: '3rem',
	900: '3.5rem',
	1000: '4rem',
	1100: '4.5rem',
	1200: '5rem',
};
